import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import usePreventRefresh from '../../../../../../../shared/utils/hooks/usePreventRefresh';
import safeLocalStorage from '../../../../../../../shared/utils/safeLocalStorage';
import { ga4Event } from '../../../../../../../shared/utils/ga4Event';
import { calculateAgencyFees } from '../../../../../../../shared/utils/helpers/hosmanVars';
import { openaiAttributionParams, trackOpenaiLead } from '../../../../../../../shared/utils/openaiAds';

import Circle from './components/Circle';
import FadeInList from './components/FadeInList';

import { FadeIn } from 'hosman-material';

import ESTIMATIONS from '../../../../../../../shared/apiPublic/ressources/estimations';
import { updateStep } from '../../../../../../reducers/_Pages/Public/estimationFunnelSlice';

const Loader = () => {
  const { funnelVersion, estimationData } = useSelector((state) => state.estimationFunnel);
  const [resultData, setResultData] = useState()
  const [isReady, setIsReady] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isRefreshAttempted = usePreventRefresh();

  const createEstimation = async () => {
    const mergedObj = Object.assign(
      {},
      estimationData.placeData,
      estimationData.mainInfos,
      estimationData.extraInfos,
      estimationData.lead,
      { kind: estimationData.typology },
      { price_expectations: parseInt(estimationData.priceExpectations.replace(/\s/g, '')) },
      { waiting_time_period: estimationData.waitingTimePeriod },
      { non_selling_reason: estimationData.nonSellingReason },
      { funnel_version: funnelVersion },
      openaiAttributionParams()
    );

    let response;
    try {
      if (safeLocalStorage.getItem('hasEffectRun') || mergedObj.email === undefined) return;

      safeLocalStorage.setItem('hasEffectRun', 'true');
      response = await ESTIMATIONS.createEstimation(mergedObj)
      setResultData(response.data)
      try {
        handleGaEvent(response.data);
      } catch (gaError) {
        console.error('Error in handleGaEvent:', gaError);
      }
      try {
        trackOpenaiLead(response.data.id || response.data.sale_id);
      } catch (pixelError) {
        console.error('Error in trackOpenaiLead:', pixelError);
      }
    } catch (e) {
      const errorMessage = e.response?.data?.error?.message?.error || 'Une erreur est survenue lors de la création de votre estimation';
      toast.error(errorMessage, { id: 'estimation-creation-fail', duration: 3000 })
      dispatch(updateStep({ stepNumber: 1 }))
    }
  }

  useEffect(() => {
    const hasEffectRun = safeLocalStorage.getItem('hasEffectRun');

    // Make sure to only create estimation once
    if (!hasEffectRun) {
      createEstimation();
    }
  }, []);

  const handleGaEvent = (responseData) => {
    const rawFees = calculateAgencyFees(
      responseData.region?.name_raw,
      responseData.last_yanport_valuation?.sale_price,
      false
    );

    const payload = {
      funnel_version: funnelVersion,
      in_zone: responseData.in_zone,
      city: responseData.property?.city,
      region: responseData.region?.name_raw,
      amount: responseData.last_yanport_valuation?.sale_price,
      hosman_fees: (typeof rawFees === 'number' && !isNaN(rawFees)) ? rawFees / 1.2 : null,
      potential_premium: responseData.potential_premium,
      potential_fine_property: responseData.potential_fine_property,
      waiting_time_period: estimationData.waitingTimePeriod,
      non_selling_reason: estimationData.nonSellingReason,
      property_kind: estimationData.typology,
      surface: estimationData.mainInfos.carrez_area || estimationData.mainInfos.living_area,
      user_id: responseData.owner?.id,
      user_email: estimationData.lead.email,
      user_phone: estimationData.lead.phone_number,
      user_first_name: estimationData.lead.first_name,
      user_last_name: estimationData.lead.last_name
    }

    ga4Event('complete_estimation', payload);
  }

  useEffect(() => {
    if (!isReady || !resultData) return;

    safeLocalStorage.removeItem('hasEffectRun');
    navigate(`/estimation/resultat/${resultData.unique_hash}`);
  }, [isReady, resultData]);

  return (
    <FadeIn>
      <div className='flex flex-col gap-10 md:w-3/5 mx-auto' data-testid='Loader'>
        <Circle resultData={resultData} setIsReady={setIsReady} />

        <p className='h2 text-ih-indigo text-center'>Première estimation de votre bien en cours...</p>

        <FadeInList />
      </div>
    </FadeIn>
  )
}

export default Loader;
